import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import SettingsSidebar from '@components/Publisher/Settings/SettingsSidebar/SettingsSidebar';
import SettingsBilling from '@components/Publisher/Settings/SettingsBilling/SettingsBilling';
import SettingsBillingDetails from '@components/Publisher/Settings/SettingsBillingDetails/SettingsBillingDetails';
import WithdrawalFeesPage from '@components/Publisher/Settings/WithdrawalFees/WithdrawalFeesPage';

import urls from '@constants/urls';
import CreateWorkspacePage from '@pages/CreateWorkspacePage/CreateWorkspacePage';
import InvoiceDetails from '@components/Settings/InvoiceDetails/InvoiceDetails';
import ErrorBoundaryNoAccess from '@uikit/old/ErrorBoundaries/ErrorBoundaryNoAccess';
import AllMembersSettings from '@components/Settings/MembersSettings/AllMembersSettings';
import ProfileSettings from '@components/Settings/ProfileSettings/ProfileSettings';
import Workspaces from '@components/Settings/Workspaces/Workspaces';
import { isStandaloneMode } from '@constants/app-modes';

import './SettingsPages.scss';

function SettingsPages(): JSX.Element {
  return (
    <div className="wrapper-publisher-settings-billing" data-testid="publisher-settings-page">
      <SettingsSidebar pathname={window.location.pathname} />
      <Switch>
        {isStandaloneMode() && (
          <Route path={urls.ALL_MEMBERS}>
            <ErrorBoundaryNoAccess>
              <AllMembersSettings />
            </ErrorBoundaryNoAccess>
          </Route>
        )}
        <Route path="/settings/billing/invoice/:invoiceId" component={InvoiceDetails} />
        <Route exact path={urls.SETTINGS_BILLING}>
          <SettingsBilling />
        </Route>
        <Route exact path={urls.SETTINGS_BILLING_DETAILS}>
          <SettingsBillingDetails />
        </Route>
        <Route exact path={urls.SETTINGS_BILLING_WITHDRAWAL_FEES}>
          <WithdrawalFeesPage />
        </Route>
        {isStandaloneMode() && (
          <Route path={urls.PROFILE}>
            <ProfileSettings />
          </Route>
        )}
        <Route path={urls.SETTINGS_WORKSPACE}>
          <Workspaces />
        </Route>
        <Route exact path={urls.SETTINGS_CREATE_WORKSPACE}>
          <CreateWorkspacePage />
        </Route>

        <Route path="*">
          {(() => {
            return <Redirect to={urls.SETTINGS_BILLING} />;
          })()}
        </Route>

        <Route path="/">
          {(() => {
            return <Redirect to={urls.SETTINGS_BILLING} />;
          })()}
        </Route>
      </Switch>
    </div>
  );
}

export default SettingsPages;
